import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { message } from '../../../../../../../utils/stringUtils';

import styles from './styles';

const OnlinePaymentPlaces = ({ places }) => (
  <div style={styles.container}>
    <UTLabel style={styles.title}>{message('PublicPayment:onlinePlacesTitle')}</UTLabel>
    {places.map(place => (
      <div style={styles.placeContainer} key={place.id}>
        <img src={place.src} alt="logo" style={styles.logo} />
        <div style={styles.placeInfo}>
          <UTLabel>{place.title}</UTLabel>
          <a href={place.link} rel="noopener noreferrer" target="_blank" style={styles.link}>
            <UTLabel blue extrabold>
              {place.link}
            </UTLabel>
          </a>
        </div>
      </div>
    ))}
  </div>
);

export const onlinePlacesPropTypes = {
  places: arrayOf(
    shape({
      id: string.isRequired,
      src: string.isRequired,
      title: string.isRequired,
      link: string.isRequired
    })
  )
};

OnlinePaymentPlaces.propTypes = onlinePlacesPropTypes;

export default Radium(OnlinePaymentPlaces);
